import { memo } from 'react';

import { GripVerticalIcon, XIcon } from 'lucide-react';

import ReorderWrapper from '@/components/atoms/ReorderWrapper/ReorderWrapper';

import styles from './ToolkitGoogleSheet.module.scss';

interface DraggableItemProps {
  id: string;
  index: number;
  item: string;
  moveItem: (dragIndex: number, hoverIndex: number) => void;
  dropItem: () => void;
  deleteItem: (id: string) => void;
  getIndex: () => number;
  disableClose?: boolean;
}

const DraggableItem: React.FC<DraggableItemProps> = ({
  id,
  index,
  item,
  moveItem,
  dropItem,
  deleteItem,
  getIndex,
  disableClose = false,
}) => {
  return (
    <li className={styles.innerContainer}>
      <ReorderWrapper
        index={index}
        moveItem={moveItem}
        dropItem={dropItem}
        getIndex={getIndex}
        dragId="tab-item"
      >
        <div className={styles.item}>
          <span>
            <GripVerticalIcon className="text-muted-foreground" size={16} />
          </span>
          <span className="text-sm leading-5 font-normal">{item}</span>
          {!disableClose && (
            <span
              className={styles.close}
              onMouseUp={() => deleteItem(id)}
              tabIndex={-1}
              role="button"
            >
              <XIcon className="text-muted-foreground" size={16} />
            </span>
          )}
        </div>
      </ReorderWrapper>
    </li>
  );
};

export default memo(DraggableItem);
